import consumer from "./consumer"

window.initiatePptxChannel = function(programReportId, enqueueUrl) {
  console.log(`Trying to connect to pptx channel for programReportId: ${programReportId}`);
  if (!programReportId) return;

  const currentUser = window.dataLayer && window.dataLayer[0] ? window.dataLayer[0].userId : null;

  const subscription = consumer.subscriptions.create({
    channel: "ProgramReportPptxChannel",
    program_report_id: programReportId,
    requester_id: currentUser
  }, {
    connected() {
      console.log(`Connected`);
      // Subscription confirmed — only now enqueue the job so its broadcast can't beat us to the stream.
      if (enqueueUrl) {
        const token = document.querySelector("meta[name='csrf-token']")?.content;
        fetch(enqueueUrl, { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": token, "Accept": "application/json" } });
      }
    },
    received(data) {
      console.log(`received; error: ${data.error}, progress: ${data.progress}, url: ${data.download_url}`);
      const pptxConversionModal = document.getElementById("pptx-conversion-modal");
      const progressBar = document.getElementById("pptx-conversion-progress");
      const progressText = document.getElementById("pptx-conversion-progress-text");
      const progressContainer = document.getElementById("pptx-conversion-progress-container");
      const successContainer = document.getElementById("pptx-conversion-success");
      const errorContainer = document.getElementById("pptx-conversion-error");
      const errorMessage = document.getElementById("pptx-conversion-error-message");
      const downloadLink = document.getElementById("pptx-download-link");

      if (data.progress !== undefined) {
        progressBar.style.width = `${data.progress}%`;
        progressBar.setAttribute("aria-valuenow", data.progress);
        progressText.textContent = `${data.progress}%`;
      }

      if (data.download_url) {
        pptxConversionModal.querySelector(".modal-title").textContent = "Your presentation is ready";
        progressContainer.classList.add("d-none");
        downloadLink.href = data.download_url;
        successContainer.classList.remove("d-none");
      }

      if (data.error) {
        pptxConversionModal.querySelector(".modal-title").textContent = "Error generating presentation";
        progressContainer.classList.add("d-none");
        errorMessage.textContent = data.error;
        errorContainer.classList.remove("d-none");
      }
    }
  });

  $("#pptx-conversion-modal").on("hidden.bs.modal", function() {
    subscription.unsubscribe();
    $("#pptx-conversion-modal").remove();
  });

  return subscription;
};
